const AUTH_ERRORS_LOCALIZATIONS = {
  login: {
    dataLoginError: {
      en: "Incorrect email or password input",
      ru: "Неверные данные электронной почты или пароля",
      de: "Falsche E-Mail- oder Passworteingabe",
    },
    loginError: {
      en: "Authorisation Error",
      ru: "Ошибка авторизации",
      de: "Autorisierungsfehler",
    },
    wrongInput: {
      en: "Invalid e-mail or password",
      ru: "Неверный e-mail или пароль",
      de: "Ungültige E-Mail oder Passwort",
    },
  },
  registration: {
    registerError: {
      en: "New user registration error",
      ru: "Ошибка регистрации нового пользователя",
      de: "Neuer Benutzerregistrierungsfehler",
    },
    dataRegisterError: {
      en: "Invalid data entered",
      ru: "Введены неверные данные",
      de: "Ungültige Daten eingegeben",
    },
    userExists: {
      en: "User already exists",
      ru: "Пользователь уже существует",
      de: "Benutzer existiert bereits",
    },
    name: {
      en: "Name cannot be empty",
      ru: "Имя не может быть пустым",
      de: "Der Name darf nicht leer sein",
    },
    password: {
      en: "Minimum password length 6 characters",
      ru: "Минимальная длинна пароля 6 символов",
      de: "Minimale Passwortlänge 6 Zeichen",
    },
    email: {
      en: "Please enter correct e-mail",
      ru: "Введите корректный e-mail",
      de: "Bitte geben Sie die richtige E-Mail-Adresse ein",
    },
  },
};

export default AUTH_ERRORS_LOCALIZATIONS;
